import axios from "axios";
import React, { useState, useEffect } from "react";
import SidebarLayout from "./components/SidebarLayout";
import Login from "./pages/Login";
import { GoogleOAuthProvider } from "@react-oauth/google";
import GlobalContext from "./utils/GlobalContext";
import { BrowserRouter as Router } from "react-router-dom";
import ChangePassword from "./pages/ChangePassword";
import {notification } from "antd";
import { ConfigProvider } from "antd";
import es_ES from 'antd/lib/locale/es_ES';
const API_URL =
  process.env.NODE_ENV !== "production"
    ? process.env.REACT_APP_SERVER_LOCAL
    : "";

function App() {
  const [loggedIn, setLoggedIn] = useState(false);
  const [changePass, setChangePass] = useState(false); 
  const [globals, setGlobals] = useState({});
  const [changeUser, setChangeUser] = useState({});
  const [currentDomain, setCurrentDomain] = useState("");
  const [oauthDomain, setOauthDomain] = useState("");

  axios.interceptors.request.use((config) => {
    const timestampTemp = localStorage.getItem('timestampTemp');
    const seg = 14350; // TIEMPO DE ESPERA 4 HORAS
    if (timestampTemp) {
      const now = new Date().getTime();
      const diff = now - timestampTemp;
      if (diff > seg*1000) {
        localStorage.clear();
        localStorage.setItem('msg_reset', "Su sesión ha expirado, por favor vuelva a iniciar sesión");
        setLoggedIn(false);
        return 
      }
    }
    
    const timestamp = localStorage.getItem('timestamp');
    if (timestamp) {
      const now = new Date().getTime();
      const diff = now - timestamp;
      
      if (diff > seg*1000) {
        localStorage.clear();
        localStorage.setItem('msg_reset', "Su sesión ha expirado, por favor vuelva a iniciar sesión");
        setLoggedIn(false);
        return
      }
      else{
        localStorage.setItem('timestampTemp', new Date().getTime());
      }
    }
    return config;
  });

  useEffect(() => {
    const msg_reset = localStorage.getItem('msg_reset');
    if (msg_reset) {
      notification.warning({
        message: msg_reset,
        placement: "top",
      });
      localStorage.removeItem('msg_reset');
    }
  },[loggedIn]);

  useEffect(() => {
    async function fetchData() {
      const response = await axios.get(`${API_URL}/globals`,
        {
          params: {
            token: process.env.REACT_APP_API_TOKEN,
          },
        }
      );
      setGlobals(response?.data?.data);
    }
    fetchData();
  }, []);

  useEffect(() => {
    if (currentDomain === 'dominio1') {
      console.log("dominio1")
      setOauthDomain(globals.OAUTH_CLIENT_ID1)
    }
    else if (currentDomain === 'dominio2') {
      console.log("dominio2")
      setOauthDomain(globals.OAUTH_CLIENT_ID2)
    }
    else if (currentDomain === 'dominio3') {
      console.log("dominio3")
      setOauthDomain(globals.OAUTH_CLIENT_ID3)
    }
    else if (currentDomain === 'dominio3_1') {
      console.log("dominio3_1")
      setOauthDomain(globals.OAUTH_CLIENT_ID3)
    }
    else if (currentDomain === 'dominio4') {
      console.log("dominio4")
      setOauthDomain(globals.OAUTH_CLIENT_ID4)
    }
  }, [currentDomain, globals]);

  const handleLogin = ({changePassTemp, userEmail, userRole, type, token, pass}) => {
    globals.userEmail = userEmail;
    globals.userRole = userRole;
    globals.type = type;
    globals.token = token;
    setChangeUser({email: userEmail, password: pass});
    if (changePassTemp) {
      setChangePass(true);
      return;
    }
    setLoggedIn(true);
  };

  const onChangedPass = () => {
    setChangePass(false);
    setLoggedIn(true);
  }

  const handleLogout = () => {
    setLoggedIn(false);
  };
  return (
    <GoogleOAuthProvider clientId={oauthDomain}>
      <GlobalContext.Provider value={globals}>
      <ConfigProvider locale={es_ES}>
        <Router>
          <div className="App">
            {changePass ? (
              <ChangePassword changeUser={changeUser} onChangedPass={onChangedPass}/>
            ) : (
            !loggedIn ? (
              <Login onLogin={handleLogin} currentDomain={currentDomain} setCurrentDomain={setCurrentDomain} />
            ) : (
              <SidebarLayout onLogout={handleLogout} />
            ))}
          </div>
        </Router>
      </ConfigProvider>
      </GlobalContext.Provider>
    </GoogleOAuthProvider>
  );
}

export default App;
